import React from "react";
import { Link } from "react-router-dom";

interface Props {
  displayIcon?: any;
  displayMsg?: string;
  btnPath?: string;
  btnLabel?: string;
  cardTitle?: string;
  btnClass?: string;
  IsMobileDevice: boolean;
  displayMsgClass?: string;
  cardTitleClass?: string;
  IsReset?: boolean;
  buttonLabel?: string;
  IsLoading?: boolean;
  OnClick?: () => void;
  displayMsgSubContent?: string;
  displayMsgSubContentClass?: string;
}

const DisplayContent: React.FunctionComponent<Props> = (props) => {
  const Icon = props.displayIcon
  return (
    <div
      className={`${props.IsMobileDevice ? "" : "p-3 br-2"} mx-auto my-auto`}
    >
      <div className="d-flex flex-direction mb-2 justify-center">
        {!!props.displayIcon && (
          <div className={"d-flex justify-center"}>
            <Icon
              className={` ${props.IsMobileDevice ? "" : "mt-0"} mb-2`}
            />
          </div>
        )}
        <div className={"my-auto d-flex justify-center"}>
          <span
            className={`color-login-subtitle ${props.IsMobileDevice ? "h1" : "h3-regular"}
              ${props.cardTitleClass}`}>
            {props.cardTitle}
          </span>
        </div>
      </div>
      <div className={"mb-1 d-flex justify-center"}>
        <span className={`${props.displayMsgClass} t-align-center`}>
          {props.displayMsg}
        </span>
      </div>
      <div className={"mb-1 d-flex justify-center"}>
        <span className={`${props.displayMsgSubContentClass} t-align-center`}>
          {props.displayMsgSubContent}
        </span>
      </div>
      {props.IsReset ? (
        <div className={"mt-3"}>
          <Link
            className={`${props.btnClass} `}
            to={props.btnPath}
            onClick={props.OnClick}
          >
            {props.btnLabel}
          </Link>
        </div>
      ) : (
        <div className={"mt-3 "}>
          <Link className={`${props.btnClass} `} to={props.btnPath}>
            {props.btnLabel}
          </Link>
        </div>
      )}
    </div>
  );
};
export default DisplayContent;
